// 端末チェック 0: iOS 1: Android 2: ほか
export const getClientType = () => {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  const isIOS =
    !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  if (isAndroid) {
    return 1
  } else if (isIOS) {
    return 0
  } else {
    return 2
  }
}

export const isMobile = () => {
  const clientType = getClientType()
  return (clientType === 0 || clientType === 1)
}
